export enum MessageDirection {
  Outgoing = 'outgoing',
  Incoming = 'incoming'
}

export enum MessageType {
  AutomatedOptIn = 'automatedOptIn',
  AutomatedWelcome = 'automatedWelcome',
  AutomatedOptOut = 'automatedOptOut',
  AutomationSms = 'automationSms',
  Direct = 'direct',
  CampaignSms = 'campaignSms',
  TestSms = 'testSms',
  ContactVerification = 'contactVerification', // supporting legacy value
  AutomatedFirstTimeTexting = 'firstTime'
}
